import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css } from 'styled-components';
import { Link, withRouter } from 'react-router-dom'
import { VelocityComponent } from 'velocity-react';
import queryString from 'qs';

import { fetchData } from '../../api'
import { fetchSettings, getSettings, updateSettings } from '../../settings'
import { media, newMedia } from '../../styles/utils'
import { container, bgImage, bgIcon, padding, hoverState } from '../../styles/global';
import { isAuthenticated } from '../../auth';

import { data } from '../Sidebar/data'
import { Nav, NavItem } from '../Sidebar/Sidebar'

import searchIcon from 'svg-react-loader?name=Icon!../../assets/icons/mobile-search.svg'
import HamburgerOpen from 'svg-react-loader?name=Icon!../../assets/icons/hamburger-open.svg'
import HamburgerClose from 'svg-react-loader?name=Icon!../../assets/icons/hamburger-close.svg'
import { cream } from '../../styles/colors';

class Header extends Component {

    constructor(props) {
        super(props);
        this.searchInput = React.createRef();
    }

    state = {
        searchActive: false,
        query: '',
        hamburgerActive: false,
    }

    componentDidMount() {
        const { fetchSettings, location } = this.props;
        
        if (location.search !== '') {
            const search = queryString.parse(location.search);
            
            this.setState({
                query: search['?query'],
            })
        }

        fetchSettings();
    }

    componentDidUpdate = (prevProps, prevState) => {
        const { location, updateSettings } = this.props;

        if (location.search !== '' && location.search !== prevProps.location.search) {
            const search = queryString.parse(location.search);
            
            this.setState({
                query: search['?query'],
            })
        }

        if (location.pathname !== '/search' && location.pathname !== prevProps.location.pathname) {
            this.setState({
                query: '',
                searchActive: false
            })
        }

        if (location.pathname !== prevProps.location.pathname) {
            this.setState({
                hamburgerActive: false
            })
        }

        if (prevState.searchActive !== this.state.searchActive && this.state.searchActive) {
            this.searchInput.current.focus(); 
        }
    }

    toggleMenu = () => {    
        const { menuActive } = this.state;
        
        this.setState({
            menuActive: !menuActive
        })
    }

    renderPageTitle  = () => {
        const { location, settings } = this.props;
        // console.log(this.props)

        return (
            <PageTitle>{settings.pageTitle}</PageTitle>
        )
        
    }

    toggleSearch = () => {
        const { updateSettings } = this.props;
        
        this.setState({
            searchActive: !this.state.searchActive
        })

        updateSettings({
            searchActive: !this.state.searchActive
        })
    }

    renderMobileNav = () => {    
        const items = data.navItems.map((item, i) => {
            return (
                <NavItem
                    key={i}
                    to={item.link}
                >
                    {item.label}
                </NavItem>  
            )
        })

        return (
            <Nav>
                <NavItem
                    to={'/'}
                >
                    {'Contents'}
                </NavItem>  
                
                {items}
            </Nav>
        )
    }

    handleSearchKeyPress = (event) => {
        const { query } = this.state;
        const { match, history } = this.props;

        // Navigate to /search on submit

        if (event.key === 'Enter') {
            history.push(`/search?query=${encodeURI(query)}`)
        }
    }

    onSearchChange = (event) => {
		this.setState({query: event.target.value});
    }
    
    toggleHamburger = () => {
        this.setState({
            hamburgerActive: !this.state.hamburgerActive
        })
    }

    renderSearch = () => {
        const { query } = this.state;

        return (
            <Search>   
                <SearchInput
                    innerRef={this.searchInput} 
                    onKeyPress={this.handleSearchKeyPress}
                    placeholder="Search..."
                    onChange={this.onSearchChange}
                    value={query}
                />
            </Search>
        )
    }

    render() {
        const { searchActive, hamburgerActive } = this.state;
        const { location, settings } = this.props;

        return (
            <Container
                display={settings.isAuthenticated}
            >
                <Main>{searchActive ? this.renderSearch() : this.renderPageTitle()}</Main>
                <Side
                    active={searchActive}
                    onClick={this.toggleSearch}
                >
                    Search   
                </Side>

                <Mobile>
                    <SearchIcon
                        onClick={this.toggleSearch}
                    />

                    <Hamburger
                        onClick={this.toggleHamburger}
                    >
                        {hamburgerActive ? <HamburgerClose/> : <HamburgerOpen/> }
                    </Hamburger>
                </Mobile>

                <MobileNav
                    active={hamburgerActive}
                >
                    {this.renderMobileNav()}
                </MobileNav>
            </Container>
        )
    }
}


const Container = styled.div`
    ${container}
    max-width: none;
    display: ${props => props.display ? 'flex' : 'none'};
    justify-content: space-between;
    align-items: center;
    height: 65px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid black;
    position: relative;

    ${media.phone`
        height: 49px;
    `}
`

const Main = styled.div`
    width: 100%;
`

const Side = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex: 1 0 360px; 
    border-left: 1px solid black;
    height: 100%;
    ${padding}
    box-sizing: border-box;
    cursor: pointer;
    
    font-size: 24px;
    text-align: right;

    ${props => {
        if (props.active) return css`
            background: #EBEADE;
        `
    }}

    ${media.phone`
        display: none;
    `}
`

// Page Title

const PageTitle = styled.div`
    display: flex;
    font-size: 24px;
    ${padding}
    transform: translateY(1px);

    ${media.phone`
        font-size: 22px;
    `}
`;

// Search

const Search = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    flex: 1 0 auto;
    width: 100%;
`;

const SearchInput = styled.input`
    background: none;
    border: none;

    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    font-size: 24px;
    ${padding}
    padding-top: 2px;
    
    &, &::placeholder {
        color: black;
    }

    &:focus { 
        outline: none;
    }

    ${media.phone`
        font-size: 22px;
        padding-top: 4px;
    `}
`


// Mobile

const Mobile = styled.div`
    display: none;  

    ${media.phone`
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 10px;
        bottom: 0;
    `}
`

const SearchIcon = styled(searchIcon)`

`

const Hamburger = styled.div`
    margin-left: 12px;
    width: 22px;
    display: flex;
    justify-content: center;
`

const MobileNav = styled.div`
    position: absolute;
    top: 49px;    
    left: 0;
    right: 0;
    background: ${cream};   
    
    opacity: 0;
    pointer-events: none;
    z-index: 11;

    ${NavItem} {
        height: 50px;
        font-size: 22px;
    }

    ${props => {
        if (props.active) return css`
            opacity: 1;
            pointer-events: all;
        `
    }}
`

const mapDispatchToProps = dispatch => ({
    fetchSettings() {
        dispatch(fetchSettings())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    settings: getSettings(state),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./client/components/Header/Header.js